import posthog from 'posthog-js'

let initialized = false

export function initPostHog(key: string, host: string) {
  if (!key || initialized) return
  posthog.init(key, {
    api_host: host || 'https://app.posthog.com',
    capture_pageview: false, // HubPageViewTracker handles SPA page views
    capture_pageleave: true,
    autocapture: false,      // HUB-10-3 wires explicit feature events
    persistence: 'localStorage',
  })
  initialized = true
}

export function posthogCapture(event: string, properties?: Record<string, unknown>) {
  if (!initialized) return
  posthog.capture(event, properties)
}

export function posthogIdentify(distinctId: string, properties?: Record<string, unknown>) {
  if (!initialized) return
  posthog.identify(distinctId, properties)
}

export function posthogReset() {
  if (!initialized) return
  posthog.reset()
}
